// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estilos gerais */
body {
    font-family: 'Arial', sans-serif;
    margin: 0;
    padding: 0;
    background-color: #f4f7fc;
}

/* Container do Dashboard */
.dashboard-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 20px;
    padding-top: 120px;
    width: 100%;
    gap: 20px; /* Espaço entre os componentes */
}

/* Sidebar de Filtros */
.filter-container {
    width: 250px;
    background-color: #f9f9f9;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    font-family: 'Arial', sans-serif;
    padding: 15px; /* Adicionando padding interno */
    margin-right: 20px;
}

.filter-title {
    font-size: 18px;
    font-weight: bold;
    color: #333;
    margin-bottom: 15px;
}

.date-range {
    margin-bottom: 15px;
}

.date-range label {
    display: block;
    font-size: 14px;
    color: #555;
    margin-bottom: 5px;
}

.date-range input[type="datetime-local"] {
    width: 85%;
    padding: 5px;
    margin-bottom: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

.row-limit {
    margin-bottom: 15px;
}

.row-limit label {
    display: block;
    font-size: 14px;
    color: #555;
    margin-bottom: 5px;
}

.row-limit input[type="number"] {
    width: 85%;
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

/* Estilos para o seletor de ordenação */
.order-direction {
    margin-bottom: 15px;
}

.order-direction label {
    display: block;
    font-size: 14px;
    color: #555;
    margin-bottom: 5px;
}

.order-direction select {
    width: 90%;
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: white;
    font-size: 14px;
    color: #555;
    cursor: pointer;
}

.order-direction select:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
}

.filter-item {
    margin-bottom: 10px;
}

.filter-item label {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #555;
}

.filter-item input[type="checkbox"] {
    margin-right: 10px;
    accent-color: #007bff; /* Cor do checkbox */
}

.filter-button {
    width: 100%;
    padding: 10px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 5px;
    font-size: 14px;
    cursor: pointer;
    margin-top: 15px;
    transition: background-color 0.3s ease;
}

.filter-button:hover {
    background-color: #0056b3;
}

/* Área Principal do Dashboard */
.dashboard-content {
    display: flex;
    justify-content: center;
    flex: 1 1;
    padding-top: 0px;
    flex-direction: row;
}

/* Bloco de Configuração do Gráfico */
.chart-settings {
    width: 250px;
    background-color: #f9f9f9; /* Cor igual à sidebar */
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    font-family: 'Arial', sans-serif;
    flex-shrink: 0;
    margin-right: 60px;
    margin-left: 20px;
}

.chart-settings-item {
    width: 90%;
    margin-bottom: 15px;
}

.chart-settings label {
    font-size: 14px;
    color: #555;
}

.chart-settings select,
.chart-settings input[type="text"],
.chart-settings input[type="checkbox"] {
    padding: 5px;
    border-radius: 4px;
    border: 1px solid #ccc;
    font-size: 14px;
    color: #555;
    background-color: white;
    width: 100%;
    margin-top: 5px;
}

.chart-settings input[type="checkbox"] {
    width: auto;
    margin-right: 10px;
}

.chart-settings select:focus,
.chart-settings input[type="text"]:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
}

/* Container do gráfico */
.chart-container {
    position: relative;
    display: flex;
    justify-content: center;
    padding: 1rem;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    height: 600px;
    flex: 1 1;
}

/* Responsividade */
@media (max-width: 768px) {
    .dashboard-container {
        flex-direction: column;
        padding: 10px; /* Pequeno padding para os dispositivos menores */
    }

    .filter-container {
        width: 100%;
        padding: 1rem;
    }

    .dashboard-content {
        padding: 1rem;
        flex-direction: column;
        gap: 20px;
    }

    .chart-settings {
        width: 100%;
    }

    .chart-container {
        width: 100%;
        height: 500px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/dashboard/stylesDashboard.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,gCAAgC;IAChC,SAAS;IACT,UAAU;IACV,yBAAyB;AAC7B;;AAEA,2BAA2B;AAC3B;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,SAAS,EAAE,gCAAgC;AAC/C;;AAEA,uBAAuB;AACvB;IACI,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,wCAAwC;IACxC,gCAAgC;IAChC,aAAa,EAAE,gCAAgC;IAC/C,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA,wCAAwC;AACxC;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,0CAA0C;AAC9C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,qBAAqB,EAAE,oBAAoB;AAC/C;;AAEA;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,gCAAgC;AAChC;IACI,aAAa;IACb,uBAAuB;IACvB,SAAO;IACP,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,qCAAqC;AACrC;IACI,YAAY;IACZ,yBAAyB,EAAE,wBAAwB;IACnD,aAAa;IACb,kBAAkB;IAClB,wCAAwC;IACxC,gCAAgC;IAChC,cAAc;IACd,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;;;IAGI,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,WAAW;IACX,uBAAuB;IACvB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;;IAEI,aAAa;IACb,qBAAqB;IACrB,0CAA0C;AAC9C;;AAEA,yBAAyB;AACzB;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;IACxC,aAAa;IACb,SAAO;AACX;;AAEA,mBAAmB;AACnB;IACI;QACI,sBAAsB;QACtB,aAAa,EAAE,iDAAiD;IACpE;;IAEA;QACI,WAAW;QACX,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,aAAa;IACjB;AACJ","sourcesContent":["/* Estilos gerais */\nbody {\n    font-family: 'Arial', sans-serif;\n    margin: 0;\n    padding: 0;\n    background-color: #f4f7fc;\n}\n\n/* Container do Dashboard */\n.dashboard-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    padding: 20px;\n    padding-top: 120px;\n    width: 100%;\n    gap: 20px; /* Espaço entre os componentes */\n}\n\n/* Sidebar de Filtros */\n.filter-container {\n    width: 250px;\n    background-color: #f9f9f9;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    font-family: 'Arial', sans-serif;\n    padding: 15px; /* Adicionando padding interno */\n    margin-right: 20px;\n}\n\n.filter-title {\n    font-size: 18px;\n    font-weight: bold;\n    color: #333;\n    margin-bottom: 15px;\n}\n\n.date-range {\n    margin-bottom: 15px;\n}\n\n.date-range label {\n    display: block;\n    font-size: 14px;\n    color: #555;\n    margin-bottom: 5px;\n}\n\n.date-range input[type=\"datetime-local\"] {\n    width: 85%;\n    padding: 5px;\n    margin-bottom: 10px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n}\n\n.row-limit {\n    margin-bottom: 15px;\n}\n\n.row-limit label {\n    display: block;\n    font-size: 14px;\n    color: #555;\n    margin-bottom: 5px;\n}\n\n.row-limit input[type=\"number\"] {\n    width: 85%;\n    padding: 5px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n}\n\n/* Estilos para o seletor de ordenação */\n.order-direction {\n    margin-bottom: 15px;\n}\n\n.order-direction label {\n    display: block;\n    font-size: 14px;\n    color: #555;\n    margin-bottom: 5px;\n}\n\n.order-direction select {\n    width: 90%;\n    padding: 5px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    background-color: white;\n    font-size: 14px;\n    color: #555;\n    cursor: pointer;\n}\n\n.order-direction select:focus {\n    outline: none;\n    border-color: #007bff;\n    box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);\n}\n\n.filter-item {\n    margin-bottom: 10px;\n}\n\n.filter-item label {\n    display: flex;\n    align-items: center;\n    font-size: 14px;\n    color: #555;\n}\n\n.filter-item input[type=\"checkbox\"] {\n    margin-right: 10px;\n    accent-color: #007bff; /* Cor do checkbox */\n}\n\n.filter-button {\n    width: 100%;\n    padding: 10px;\n    background-color: #007bff;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    font-size: 14px;\n    cursor: pointer;\n    margin-top: 15px;\n    transition: background-color 0.3s ease;\n}\n\n.filter-button:hover {\n    background-color: #0056b3;\n}\n\n/* Área Principal do Dashboard */\n.dashboard-content {\n    display: flex;\n    justify-content: center;\n    flex: 1;\n    padding-top: 0px;\n    flex-direction: row;\n}\n\n/* Bloco de Configuração do Gráfico */\n.chart-settings {\n    width: 250px;\n    background-color: #f9f9f9; /* Cor igual à sidebar */\n    padding: 20px;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    font-family: 'Arial', sans-serif;\n    flex-shrink: 0;\n    margin-right: 60px;\n    margin-left: 20px;\n}\n\n.chart-settings-item {\n    width: 90%;\n    margin-bottom: 15px;\n}\n\n.chart-settings label {\n    font-size: 14px;\n    color: #555;\n}\n\n.chart-settings select,\n.chart-settings input[type=\"text\"],\n.chart-settings input[type=\"checkbox\"] {\n    padding: 5px;\n    border-radius: 4px;\n    border: 1px solid #ccc;\n    font-size: 14px;\n    color: #555;\n    background-color: white;\n    width: 100%;\n    margin-top: 5px;\n}\n\n.chart-settings input[type=\"checkbox\"] {\n    width: auto;\n    margin-right: 10px;\n}\n\n.chart-settings select:focus,\n.chart-settings input[type=\"text\"]:focus {\n    outline: none;\n    border-color: #007bff;\n    box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);\n}\n\n/* Container do gráfico */\n.chart-container {\n    position: relative;\n    display: flex;\n    justify-content: center;\n    padding: 1rem;\n    background-color: #fff;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    height: 600px;\n    flex: 1;\n}\n\n/* Responsividade */\n@media (max-width: 768px) {\n    .dashboard-container {\n        flex-direction: column;\n        padding: 10px; /* Pequeno padding para os dispositivos menores */\n    }\n\n    .filter-container {\n        width: 100%;\n        padding: 1rem;\n    }\n\n    .dashboard-content {\n        padding: 1rem;\n        flex-direction: column;\n        gap: 20px;\n    }\n\n    .chart-settings {\n        width: 100%;\n    }\n\n    .chart-container {\n        width: 100%;\n        height: 500px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
